/**
 * WHAT A PERSON'S CHOICES WOULD DO TO A MESSAGE, IN THE OFFICE'S WORDS (ops #76 phase 2,
 * `docs/plan-preferences.md` section 7). The server answers, per person, kind and channel, the words a
 * message would be parked with, led by `not sent: `, and whether the office would be given the call
 * (the guard: a change to a visit for the visit contact, or an invoice for the money contact, with no
 * way open to them). Every screen that sends says it before the press, in the same words, and the
 * answer after it says it again. UX only: the composers ask it all again and park in the same words.
 */
import type { ChannelPreview } from './api.ts';

/** What the office does where a guarded message would be parked: the contract's guard line. */
export const OFFICE_CALLS_LINE = 'With email and texts off for this, the office will call them.';

/** The words a parked message keeps, as a sentence: their lead taken off, ending with a full stop. */
export function choiceWords(notSent: string): string {
  const words = notSent.replace(/^not sent:\s*/, '').trim();
  return /[.!?]$/.test(words) ? words : `${words}.`;
}

/** The line drawn before the press where their choice or a hold would park it, or null where it goes. */
export function choiceLineOf(preview: ChannelPreview | null | undefined): string | null {
  if (!preview || preview.notSent === null) return null;
  const line = `This would not go: ${choiceWords(preview.notSent)}`;
  return preview.officeCalls ? `${line} ${OFFICE_CALLS_LINE}` : line;
}

/** The answer after the press where it was parked, naming who, or null where it went. */
export function choiceSentOf(
  name: string,
  refusal: string | null | undefined,
  officeCalls: boolean | undefined,
): string | null {
  if (!refusal) return null;
  const line = `Nothing was sent to ${name}: ${choiceWords(refusal)}`;
  return officeCalls
    ? `${line} With email and texts off for this, a task gives the office the call.`
    : line;
}
